module.exports = __webpack_public_path__ + "img/youtobe.63bd0d8c.svg";